
// AppLayout import removed
import { SettingsTabs } from "@/components/settings/SettingsTabs";
import { useIsAdmin } from "@/hooks/useIsAdmin";

export default function Settings() {
  const { data: isAdmin } = useIsAdmin();

  return (
    // AppLayout wrapper removed
    <div>
      <h1 className="text-3xl font-bold mb-6">Settings</h1>
      <SettingsTabs />
    </div>
  );
}
